import { translate as t } from '@thoughtspot/i18n';
import { ElementType } from '@thoughtspot/radiant-react/widgets/form-builder/interface';
import { NEW_CHARTS_DEFAULT_FIELD_ID, TranslationKeys, } from './settings.constants';
export const buildToggleField = (value) => {
    const label = t(TranslationKeys.NEW_CHARTS_DEFAULT_LABEL);
    return {
        id: NEW_CHARTS_DEFAULT_FIELD_ID,
        elementType: ElementType.TOGGLE,
        config: {
            label,
            labelText: label,
        },
        value: String(value),
        valueLabels: {
            true: t(TranslationKeys.ENABLED_LABEL),
            false: t(TranslationKeys.DISABLED_LABEL),
        },
    };
};
//# sourceMappingURL=settings.field.js.map